import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ExternalInstitutionDataTable from '../../../../components/datatables/postSecondary/ExternalInstitutionDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface ExternalInstitutionListProps {
}

interface ExternalInstitutionListState {
}

class ExternalInstitutionListPage extends React.Component<ExternalInstitutionListProps & RouteComponentProps<RouteObject>, ExternalInstitutionListState> {
  constructor(props: ExternalInstitutionListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="External Institution" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.externalInstitutionList()} />

        <Card >
          <ExternalInstitutionDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(ExternalInstitutionListPage);
